module.exports = __webpack_public_path__ + "static/media/table_locked.a58b577d.png";